const header = {
  'links': {
    'industries': 'Secteurs d\'activité',
    'solutions': 'Solutions',
  },
  'contact': 'Contact',
}

export default header
